import { useEffect } from "react";
import * as Sentry from "@sentry/react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

const fetchKeyConfig = async () => {
  const url = '/console-config/env.json';
  const response = await fetch(url);
  const config = await response.json();
  const apiUrl = config.apiUrl;

  const keys = {
    'https://dev.vially.io': "https://11def1b2e846e751753a859045cca9e1@o4508444940304384.ingest.de.sentry.io/4508449211351120",
    'https://test.vially.io': "https://ebc95e3b4f70ca35be0bbd19d23aef13@o4508444940304384.ingest.de.sentry.io/4508449217577040",
    'https://staging.vially.io': "https://8be971baed3cb1cc1843b7cb5a45b352@o4508444940304384.ingest.de.sentry.io/4508449219215440",
    'https://vially.io': "https://59f1169d00ca3f9b3494b3518d4ba453@o4508444940304384.ingest.de.sentry.io/4508449222623312"
  };

  return keys[apiUrl];
};
Sentry.init({
  dsn: await fetchKeyConfig(),
  integrations: [
    // See docs for support of different versions of variation of react router
    // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.replayIntegration(),
  ],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for tracing.
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/configuration/options/#traces-sample-rate
  tracesSampleRate: 1.0,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: [/^\//, /^https:\/\/yourserver\.io\/api/],

  // Capture Replay for 10% of all sessions,
  // plus for 100% of sessions with an error
  // Learn more at
  // https://docs.sentry.io/platforms/javascript/session-replay/configuration/#general-integration-configuration
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});
